import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowDown, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
import SectionHeading from '../common/SectionHeading';
import NewsCard from '../common/NewsCard';

function FeedSection({ title, catId, items = [], onOpen, onViewAll, color, limit = 6, expandTo, hideViewAll, inline, moreLink }) {
  const [expanded, setExpanded] = useState(false);
  const navigate = useNavigate();

  if (!Array.isArray(items) || items.length === 0) return null;

  const showCount = inline && !expanded ? Math.min(limit, items.length) : expandTo || items.length;
  const visible = items.slice(0, showCount);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className="mb-8"
    >
      <SectionHeading title={title} catId={catId} onViewAll={hideViewAll ? null : onViewAll} color={color} />
      <div className="grid gap-7 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-8 w-full">
        {visible.map((item) => (
          <NewsCard key={item.id} item={item} onOpen={onOpen} />
        ))}
      </div>
      {/* "सबै हेर्नुहोस्" — 6 न्युजपछि section ko अन्त्यमा पनि */}
      {!hideViewAll && onViewAll && (
        <div className="flex justify-center mb-10">
          <button
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-crimson text-crimson font-bold text-[13.5px] hover:bg-crimson hover:text-white transition-colors"
            onClick={onViewAll}
          >
            सबै हेर्नुहोस् <ArrowRight size={16} />
          </button>
        </div>
      )}
      {inline && !expanded && items.length > limit && (
        <div className="flex justify-center mb-10">
          <button
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-crimson text-crimson font-bold text-[13.5px] hover:bg-crimson hover:text-white transition-colors"
            onClick={() => {
              // moreLink diyema extend hoina — tyahi page ma lanchha
              if (moreLink) {
                navigate(moreLink);
              } else {
                setExpanded(true);
              }
            }}
          >
            थप हेर्नुहोस् {moreLink ? <ArrowRight size={16} /> : <ArrowDown size={16} />}
          </button>
        </div>
      )}
    </motion.div>
  );
}

export default FeedSection;